import { useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import theme from "../theme/theme";
import logo from "../assets/logo.png";
import { getAccessToken } from "../redux/cookie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTachometerAlt,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import LogoutButton from "./LogoutButton";
import WelcomeMessage from "./WelcomeMessage/WelcomeMessage";
import AccountDetailsModal from "./AccountDetailsModal/AccountDetailsModal";
import { useEffect } from "react";
import { getUserAccountDetails, getCompanyLogo } from "../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { SET_LOADING } from "../redux/action-types";
import GarwoodHelpPopup from "./GarwoodHelpPopup/GarwoodHelpPopup";

const Wrapper = styled.header`
  background-color: ${theme.colors.white};
  padding: 15px 40px;
  box-sizing: border-box;
  max-height: 75px;

  nav {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: auto;
  }

  .logo {
    cursor: pointer;
    width: 200px;
    @media (max-width: 480px) {
      width: 150px;
      margin-right: 10px;
    }
  }

  @media (max-width: 480px) {
    padding: 15px 5%;
    max-height: 65px;
  }
`;

const LoginLink = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  @media (max-width: 430px) {
    .link_text {
      display: none;
    }
  }
`;

const DashboardLink = styled(Link)`
  border-bottom: 3px solid ${theme.colors.primary};
  padding: 5px 5px;
  letter-spacing: 0px;
  line-height: 1.25;
  text-decoration: none;
  color: ${theme.colors.primaryStrong2X};
  height: fit-content;
  font-weight: 700;

  &:hover {
    color: ${theme.colors.primary};
  }
`;

const HelpLink = styled.a`
  border-bottom: ${(props) =>
    `${
      props.isUnderlineVisible
        ? `3px solid ${theme.colors.primary}`
        : "3px solid white"
    }`};
  padding: 5px;
  letter-spacing: 0px;
  line-height: 1.25;
  text-decoration: none;
  color: ${theme.colors.primaryStrong2X};
  height: fit-content;
  font-weight: 700;
  cursor: pointer;
  te &:hover {
    color: ${theme.colors.primary};
  }

  .userName {
    color: ${theme.colors.primary};
  }
`;

const Header = () => {
  const [isLogoutButtonVisible, setIsLogoutButtonVisible] = useState(false);
  const [isAccountDetailsModalVisible, setIsAccountDetailsModalVisible] =
    useState(false);
  const [isHelpPopupVisible, setIsHelpPopupVisible] = useState(false);
  const { userAccountDetails, companyLogo } = useSelector(
    (state) => state.user
  );
  const history = useHistory();
  const dispatch = useDispatch();

  const handleLogoClick = () => {
    if (getAccessToken()) {
      history.push("/strategy-screen");
    } else {
      //history.push("/");
      window.open("https://tactivewealth.com/", "_blank");
    }
  };

  useEffect(() => {
    dispatch(getUserAccountDetails());
    dispatch({ type: SET_LOADING, payload: true });
    if (companyLogo == null) {
      dispatch(getCompanyLogo());
    }
  }, [dispatch]);

  return (
    <Wrapper
      onClick={() => {
        setIsLogoutButtonVisible(false);
      }}
    >
      {isAccountDetailsModalVisible && (
        <AccountDetailsModal onClose={setIsAccountDetailsModalVisible} />
      )}
      {isLogoutButtonVisible && (
        <LogoutButton userAccountDetails={userAccountDetails} />
      )}
      <nav>
        {/* <LogoIcon className="logo" onClick={handleLogoClick} /> */}
        <img
          className="logo"
          src={companyLogo || logo}
          alt="logo"
          onClick={handleLogoClick}
        />
        <LoginLink>
          <WelcomeMessage
            actionOnClick={() => {
              setIsAccountDetailsModalVisible(true);
            }}
          />
          <LoginLink>
            {isHelpPopupVisible && (
              <GarwoodHelpPopup setIsHelpPopupVisible={setIsHelpPopupVisible} />
            )}
            {true && (
              <HelpLink
                isUnderlineVisible={isHelpPopupVisible}
                onClick={() => {
                  setIsHelpPopupVisible(true);
                }}
              >
                Help
              </HelpLink>
            )}
          </LoginLink>
          <DashboardLink to="/strategy-screen">
            <FontAwesomeIcon icon={faTachometerAlt} />
            <span className="link_text"> Dashboard</span>
          </DashboardLink>
          <FontAwesomeIcon
            style={{ marginLeft: "7px", cursor: "pointer" }}
            icon={faChevronDown}
            onClick={(e) => {
              e.stopPropagation();
              setIsLogoutButtonVisible(!isLogoutButtonVisible);
            }}
          />
        </LoginLink>
      </nav>
    </Wrapper>
  );
};

export default Header;
